import { render, staticRenderFns } from "./checkout-summary.vue?vue&type=template&id=7023b8aa&"
import script from "./checkout-summary.vue?vue&type=script&lang=js&"
export * from "./checkout-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports